enum Channel {
  DEFAULT = 'DEFAULT',
  MIRROR = 'MIRROR'
}

export default Channel
